import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { NavDropdownHover } from './NavDropdownHover';
import { Link } from 'react-router-dom';
import { Banner } from './Banner';
import { routes } from '../../../routes';
import './Header.css';

export const Header: React.FC = () => {
  let routeIndex = 0;
  const routeLinks = routes.map((route) => {
    routeIndex += 1;
    if (!route.isDropdown)
      return (
        <Nav.Link
          className="text-uppercase"
          as={Link}
          to={route.path}
          key={route.label}
          eventKey={routeIndex}
        >
          {route.label}
        </Nav.Link>
      );
    else {
      return (
        <NavDropdownHover title={route.label} key={route.label}>
          {route.children?.map((dropdownItem) => {
            routeIndex += 1;
            return (
              <NavDropdown.Item
                as={Link}
                to={dropdownItem.path}
                key={dropdownItem.label}
                className="text-uppercase"
                eventKey={routeIndex}
              >
                {dropdownItem.label}
              </NavDropdown.Item>
            );
          })}
        </NavDropdownHover>
      );
    }
  });

  return (
    <Container as="header" className="bg-grey shadow-lg">
      <Banner />
      <Row className="navbar-bg">
        <Navbar variant="dark" collapseOnSelect expand="lg">
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse
            id="basic-navbar-nav"
            className="justify-content-center"
          >
            <Nav>{routeLinks}</Nav>
          </Navbar.Collapse>
        </Navbar>
      </Row>
    </Container>
  );
};
